import { Navigate } from 'react-router'

import { withNamespaces } from '@/i18n/route-namespaces'

export const followUpRoutes = {
  path: 'follow-up',
  lazy: withNamespaces(['followUp', 'knowledgeBase'], async () => {
    const { FollowUp } = await import('@/pages/follow-up')

    return { Component: FollowUp }
  }),
  children: [
    {
      index: true,
      element: <Navigate to="bot-rules" />,
    },
    {
      path: 'bot-rules',
      lazy: withNamespaces(['followUp', 'knowledgeBase'], async () => {
        const { BotRules } = await import('@/pages/follow-up/bot-rules')

        return { Component: BotRules }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['followUp', 'knowledgeBase'], async () => {
            const { BotRulesList } = await import(
              '@/pages/follow-up/bot-rules/list'
            )

            return { Component: BotRulesList }
          }),
        },
      ],
    },
  ],
}
